import { type ComponentType, memo, type ReactElement } from "react";

import type { DynamicFilterGroupValue } from "app/pages/sales-intelligence/domain/search/types/dynamic-filter-values";

import type { DynamicGroupFilter } from "../../../models/DynamicGroupFilter";
import type { IFilterViewBaseModelProps } from "../../../types/filterInstance";
import type { SearchFilterInstance } from "../../../types/searchFilterInstance";

type FieldProps = {
    readonly group: DynamicGroupFilter;
    readonly field: SearchFilterInstance;
    readonly groupValue: DynamicFilterGroupValue;
    readonly isActionEnabled?: boolean;
    readonly disabledOptionIds?: readonly string[];
    readonly isTopLayer?: boolean;
    readonly view?: ComponentType<IFilterViewBaseModelProps<unknown>>;
    readonly onFilterUpdate: (value?: DynamicFilterGroupValue) => void;
};

const GroupFieldBase = ({
    group,
    field,
    groupValue,
    isActionEnabled,
    disabledOptionIds,
    isTopLayer,
    onFilterUpdate,
    view: View,
}: FieldProps): ReactElement | null => {
    const fieldModel = field.filter;

    const handleUpdate = (raw?: unknown): void => onFilterUpdate(group.writeField(groupValue, field, raw));

    if (!View) {
        return null;
    }

    return (
        <View
            filter={fieldModel}
            value={fieldModel.fromApiValue(groupValue[field.key])}
            isExpanded
            isActionEnabled={isActionEnabled}
            disabledOptionIds={disabledOptionIds}
            isTopLayer={isTopLayer}
            onFilterUpdate={handleUpdate}
            onFilterValueRemove={handleUpdate}
        />
    );
};

export const GroupField = memo(GroupFieldBase);
